const AuditIndex = () => import('views/ai/AuditIndex')
const AiChat = () => import('views/ai/AiChat')
const GpuDashboard = () => import('views/ai/GpuDashboard')
const AudioAudit = () => import('views/ai/AudioAudit')
const ImageAudit = () => import('views/ai/ImageAudit')
const VideoAudit = () => import('views/ai/VideoAudit')
const TextAudit = () => import('views/ai/TextAudit')

export default {
  path: '/ai',
  name: 'AuditIndex',
  component: AuditIndex,
  meta: { needAuth: true },
  children: [
    {
      path: '',
      name: 'AiChat',
      component: AiChat,
      meta: { title: 'AiChat', needAuth: false }
    },
    {
      path: '/ai/gpu',
      name: 'GpuDashboard',
      component: GpuDashboard,
      meta: { title: 'GPU 信息', needAuth: true }
    },
    {
      path: '/ai/audio',
      hidden: true,
      name: 'AudioAudit',
      component: AudioAudit,
      meta: { title: '音频识别', needAuth: true }
    },
    {
      path: '/ai/image',
      hidden: true,
      name: 'ImageAudit',
      component: ImageAudit,
      meta: { title: '图像理解', needAuth: true }
    },
    {
      path: '/ai/video',
      hidden: true,
      name: 'VideoAudit',
      component: VideoAudit,
      meta: { title: '视频审核', needAuth: true }
    },
    {
      path: '/ai/text',
      hidden: true,
      name: 'TextAudit',
      component: TextAudit,
      meta: { title: '文本分析', needAuth: true }
    }
  ]
}
